import React from 'react'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

import withGeneralTranslations from '../hocs/withGeneralTranslations'

import Navigation from '../layouts/Navigation'
import Paragraph from '../styleguide/Paragraph'

const styles = theme => ({
  containerStyle: {
    flex: '1 0 auto',
    padding: '0 36px 0 36px'
  },
  gridStyle: {
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  messageStyle: {
    marginTop: 70
  }
})

const Disclaimer = ({
  generalTranslations,
  classes: { containerStyle, gridStyle, messageStyle }
}) => (
  <div className={containerStyle}>
    <Grid container spacing={0} className={gridStyle}>
      <Navigation enableOverviewShortcuts={false} onlyShowHome />
      <Paragraph className={messageStyle}>
        {generalTranslations('not-found')}
      </Paragraph>
    </Grid>
  </div>
)

export default compose(
  withGeneralTranslations,
  withStyles(styles)
)(Disclaimer)



// WEBPACK FOOTER //
// ./src/screens/NotFound.js